import React from 'react';
import localStrings from "../../localStrings";
import GenericSparkDataSpark from "./GenericSparkDataSpark";
import {formatEurPriceAndRoundUtil} from "../../utils/currencyUtil";
import {Ticket01} from "@untitled-ui/icons-react";
import {useMediaQuery} from "@mui/material";

function AverageTicketSpark() {

    const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
    // Force graph mode for testing - change to md or sm for lower screen sizes
    const forceGraphMode = useMediaQuery((theme) => theme.breakpoints.up("md"));
    return (
        <GenericSparkDataSpark
            modeGraph={forceGraphMode}
            getterData={(data) => data?.averageTicket}
            title={localStrings.averageTicket}
            getterTotalSingleDay={(data) => {
                return data?.length === 1 ? data[0].averageTicket : 0
            }}
            getterTotalMultiDay={(data) => {
                const totalOrder =  data.reduce((acc, curr) => acc + (curr.totalOrders || 0), 0);
                const totalSales = data.reduce((acc, curr) => acc + (curr.totalTurnover || 0), 0);
                return totalOrder > 0 ? totalSales / totalOrder : 0;
            }}
            formatter={(value, lgUp) => {
                return formatEurPriceAndRoundUtil(value , lgUp);
            }}
            backgroundColor={(theme) => theme.palette.mode === 'dark'
                ? 'neutral.800'
                : 'error.lightest'}
            icon={<Ticket01/>}

        />
    )
}

export default AverageTicketSpark